// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4873":"ac06817b38c65ea5","6571":"daa2a51fa63b0216"}[chunkId] + ".css";
};